/* eslint-disable */
/*
 * The fireworks over the Theresienwiese behind the sign-in pages (Components/Auth/AuthNightSky.vue),
 * drawn over the night view of Munich (public/images/ds-login/munich-night.webp, 1672 x 941).
 *
 * The show is the website footer's, unchanged (airlst2027 www/assets/js/footer-sky.js, the fireworks
 * block): five acts, the same effect types (comet, peony, chrysanthemum, willow, crossette, palm,
 * ring, strobe, mine, salute) and colours. Only the stage moved to the new picture: the shells rise
 * from the Oktoberfest grounds between the ferris wheel and the tents (y 800) and open just above
 * the Alps. X() and T() carry the footer's positions (2172 x 432) over to this picture; the canvas
 * is drawn in picture coordinates through the same cover transform as the picture behind it.
 *
 * Kept as the website wrote it (ES5, terse), so the two stay easy to compare; not linted.
 */

var W0 = 1672, H0 = 941;

/** The footer's x (Wiesn around 1440) to this picture's Wiesn (around 1330). */
function X(x) { return x - 110; }
/** The footer's opening height above its ground (292) to this picture's sky above the Alps. */
function T(top) { return 800 - (292 - top) * 1.5; }

export function startFireworks(cv) {
  var reduced = false;
  try { reduced = matchMedia("(prefers-reduced-motion: reduce)").matches; } catch (e) {}
  var ctx = cv.getContext && cv.getContext("2d");
  if (reduced || !ctx) { return function () {}; }

  var stopped = false, k = 1, view = { scale: 1, x: 0, y: 0 };
  var fit = function () {
    var dpr = Math.min(1.5, window.devicePixelRatio || 1);
    cv.width = Math.round(cv.clientWidth * dpr); cv.height = Math.round(cv.clientHeight * dpr);
    var scale = Math.max(cv.width / W0, cv.height / H0);
    view = { scale: scale, x: (cv.width - W0 * scale) / 2, y: (cv.height - H0 * scale) / 2 };
  };
  fit();
  var ro = window.ResizeObserver ? new ResizeObserver(fit) : null;
  if (ro) { ro.observe(cv); } else { window.addEventListener("resize", fit); }

  var rnd = Math.random, TAU = Math.PI * 2;
  var GROUND = 800;                      /* Abschussniveau: Wiesn-Gelände in Bildkoordinaten (munich-night, 1672 x 941) */
  /* Farbsätze [Kern, Rand]: Gold wie die Riesenrad-Lampen, Orange wie das Zeltlicht,
     Rosé wie der Abendhimmel, Silber, AirLST-Violett */
  var C = {
    gold:   ["#fff3d6", "#ffc46b"],
    orange: ["#ffe9d2", "#ff9b6a"],
    rose:   ["#fff1e8", "#ff8fa3"],
    silver: ["#ffffff", "#dfe6ff"],
    violet: ["#f3ecff", "#b48cf2"]
  };
  var warm = [C.gold, C.orange, C.rose];
  function pick(a) { return a[Math.floor(rnd() * a.length)]; }

  /* ---------- Partikelsystem ---------- */
  var shells = [], sparks = [], MAX = 2600;
  function spark(x, y, vx, vy, o) {
    if (sparks.length > MAX) return;
    sparks.push({ x: x, y: y, px: x, py: y, vx: vx, vy: vy, t0: o.now, life: o.life, pal: o.pal,
      r: o.r, trail: o.trail || 2.2, drag: o.drag || 0.975, g: o.g || 22, glitter: !!o.glitter,
      split: o.split || 0, flash: !!o.flash, fade: o.fade || 1.6 });
  }
  /* Bombe: steigt vom Boden auf und öffnet auf Höhe top */
  function shell(now, o) {
    var x = o.x !== undefined ? o.x : X(1350 + rnd() * 180);
    shells.push({ x: x, x0: x, y: GROUND, top: o.top, t0: now, dur: o.dur || (1000 + 260 * (o.size || 1)),
      type: o.type, size: o.size || 1, pal: o.pal || pick(warm), drift: (rnd() - 0.5) * 20, comet: !!o.comet });
  }
  /* Öffnung je Effekttyp */
  function open(s, now) {
    var n, i, a, v, S = s.size, pal = s.pal, x = s.x, y = s.y, base = { now: now, pal: pal };
    function o(extra) { var r = {}, key; for (key in base) r[key] = base[key]; for (key in extra) r[key] = extra[key]; return r; }
    switch (s.type) {
      case "peony":          /* Pfingstrose: dichte Kugel, kurze Spuren */
        n = Math.round(70 + 40 * S);
        for (i = 0; i < n; i++) { a = i / n * TAU + rnd() * 0.1; v = (0.55 + rnd() * 0.45) * (26 + 18 * S);
          spark(x, y, Math.cos(a) * v, Math.sin(a) * v, o({ life: 1700 + rnd() * 700, r: 1.2 + rnd() * 0.8 })); }
        spark(x, y, 0, 0, o({ life: 240, flash: true, r: 34 * S }));
        break;
      case "chrys":          /* Chrysantheme: wie Pfingstrose, aber lange Schweife und Glitzer */
        n = Math.round(80 + 40 * S);
        for (i = 0; i < n; i++) { a = i / n * TAU + rnd() * 0.1; v = (0.6 + rnd() * 0.4) * (28 + 20 * S);
          spark(x, y, Math.cos(a) * v, Math.sin(a) * v, o({ life: 2100 + rnd() * 800, r: 1.1 + rnd() * 0.7, trail: 4.5, glitter: rnd() < 0.5 })); }
        spark(x, y, 0, 0, o({ life: 260, flash: true, r: 40 * S }));
        break;
      case "willow":         /* Weide: schwere Goldfunken, hängen lange und sinken */
        n = Math.round(60 + 30 * S);
        for (i = 0; i < n; i++) { a = i / n * TAU + rnd() * 0.15; v = (0.5 + rnd() * 0.5) * (22 + 14 * S);
          spark(x, y, Math.cos(a) * v, Math.sin(a) * v * 0.8, o({ life: 3800 + rnd() * 1400, r: 1.0 + rnd() * 0.6, trail: 3.2, drag: 0.985, g: 14, fade: 1.2, pal: C.gold })); }
        spark(x, y, 0, 0, o({ life: 300, flash: true, r: 36 * S, pal: C.gold }));
        break;
      case "crossette":      /* Crossette: wenige dicke Sterne, die sich nach kurzer Zeit vierfach teilen */
        n = 12 + Math.round(6 * S);
        for (i = 0; i < n; i++) { a = i / n * TAU + rnd() * 0.2; v = (0.7 + rnd() * 0.3) * (22 + 12 * S);
          spark(x, y, Math.cos(a) * v, Math.sin(a) * v, o({ life: 700 + rnd() * 250, r: 2.2, trail: 3, split: 1 })); }
        spark(x, y, 0, 0, o({ life: 220, flash: true, r: 26 * S }));
        break;
      case "palm":           /* Palme: wenige dicke Arme, die aufsteigen und sich überbiegen */
        n = 8 + Math.round(4 * S);
        for (i = 0; i < n; i++) { a = -Math.PI / 2 + (i / (n - 1) - 0.5) * 2.4 + (rnd() - 0.5) * 0.15; v = (0.85 + rnd() * 0.15) * (34 + 18 * S);
          spark(x, y, Math.cos(a) * v, Math.sin(a) * v, o({ life: 2400 + rnd() * 600, r: 2.4 + rnd() * 0.8, trail: 5.5, drag: 0.982, g: 26, pal: pal })); }
        spark(x, y, 0, 0, o({ life: 260, flash: true, r: 30 * S }));
        break;
      case "ring":           /* Ring: Sterne mit exakt gleicher Geschwindigkeit, leicht gekippt */
        n = Math.round(56 + 20 * S); var tilt = 0.55 + rnd() * 0.35, rot = (rnd() - 0.5) * 0.8;
        for (i = 0; i < n; i++) { a = i / n * TAU; v = 30 + 14 * S;
          var rx = Math.cos(a) * v, ry = Math.sin(a) * v * tilt;
          spark(x, y, rx * Math.cos(rot) - ry * Math.sin(rot), rx * Math.sin(rot) + ry * Math.cos(rot), o({ life: 1900 + rnd() * 300, r: 1.5, trail: 2.5, drag: 0.978 })); }
        break;
      case "strobe":         /* Glitzerbombe: silberne, blinkende Sterne, wenig Bewegung */
        n = Math.round(90 + 40 * S);
        for (i = 0; i < n; i++) { a = rnd() * TAU; v = rnd() * (20 + 12 * S);
          spark(x, y, Math.cos(a) * v, Math.sin(a) * v, o({ life: 2600 + rnd() * 1200, r: 1.1 + rnd() * 0.9, trail: 1.2, drag: 0.97, g: 10, glitter: true, pal: C.silver })); }
        break;
      case "salute":         /* Salut: nur ein harter weißer Blitz und ein Kranz kurzer Funken */
        spark(x, y, 0, 0, o({ life: 380, flash: true, r: 90 * S, pal: C.silver }));
        n = 40;
        for (i = 0; i < n; i++) { a = i / n * TAU; v = (0.6 + rnd() * 0.4) * 40;
          spark(x, y, Math.cos(a) * v, Math.sin(a) * v, o({ life: 500 + rnd() * 200, r: 1.4, trail: 2, pal: C.silver })); }
        break;
    }
  }
  /* Bodenmine: Fächer aus Kometen direkt vom Wiesn-Gelände, ohne Aufstieg */
  function mine(now, x, size, pal) {
    var n = 9 + Math.round(5 * size), i, a, v;
    for (i = 0; i < n; i++) { a = -Math.PI / 2 + (rnd() - 0.5) * 0.9; v = (0.7 + rnd() * 0.3) * (70 + 30 * size);
      spark(x, GROUND, Math.cos(a) * v, Math.sin(a) * v, { now: now, pal: pal || C.gold, life: 1100 + rnd() * 500, r: 1.8, trail: 4, drag: 0.98, g: 40 }); }
    spark(x, GROUND - 4, 0, 0, { now: now, pal: pal || C.gold, life: 180, flash: true, r: 12 * size });
  }

  /* ---------- Choreografie: Cue-Liste je Show ---------- */
  var SHOW_LEN = 74000, PAUSE = 22000;
  function compose() {
    var cues = [], t, i, x;
    function cue(t, fn) { cues.push({ t: t, fn: fn }); }
    function sh(t, o) { cue(t, function (now) { shell(now, o); }); }
    /* Akt 1: Auftakt. Einzelne Kometen und eine kleine Pfingstrose, dazwischen Luft. */
    sh(600,   { type: "peony", size: 0.55, top: T(175), pal: C.gold, comet: true });
    sh(4200,  { type: "peony", size: 0.6, top: T(168), pal: C.orange, comet: true });
    sh(7600,  { type: "crossette", size: 0.6, top: T(172), pal: C.gold });
    sh(10800, { type: "peony", size: 0.7, top: T(160), pal: C.rose, comet: true });
    /* Akt 2: Aufbau. Paare im Wechsel, erste Weide, Farben wechseln. */
    for (i = 0; i < 5; i++) {
      t = 14000 + i * 3600;
      sh(t,        { type: i % 2 ? "chrys" : "peony", size: 0.7 + i * 0.05, top: T(150 - i * 4), x: X(1360 + rnd() * 60), pal: warm[i % 3] });
      sh(t + 700,  { type: i % 2 ? "peony" : "chrys", size: 0.7 + i * 0.05, top: T(152 - i * 4), x: X(1460 + rnd() * 60), pal: warm[(i + 1) % 3] });
    }
    sh(24500, { type: "willow", size: 0.9, top: T(140), x: X(1420) });
    sh(31000, { type: "crossette", size: 0.9, top: T(146), x: X(1400), pal: C.violet });
    sh(31600, { type: "ring", size: 0.8, top: T(140), x: X(1480), pal: C.silver });
    /* Akt 3: Steigerung. Dreier-Salven im Takt, Palmen, Ringe, Glitzer, Minen vom Boden. */
    for (i = 0; i < 6; i++) {
      t = 34000 + i * 3000;
      sh(t,        { type: ["palm", "chrys", "peony"][i % 3], size: 0.85 + i * 0.05, top: T(138 - i * 3), x: X(1365 + rnd() * 30), pal: warm[i % 3] });
      sh(t + 350,  { type: ["ring", "strobe", "chrys"][i % 3], size: 0.85 + i * 0.05, top: T(128 - i * 3), x: X(1440 + rnd() * 30), pal: i % 3 === 1 ? C.silver : warm[(i + 1) % 3] });
      sh(t + 700,  { type: ["chrys", "palm", "willow"][i % 3], size: 0.85 + i * 0.05, top: T(140 - i * 3), x: X(1505 + rnd() * 30), pal: i % 3 === 2 ? C.gold : warm[(i + 2) % 3] });
      cue(t + 1400, function (now) { mine(now, X(1380 + rnd() * 30), 0.8, C.gold); mine(now, X(1500 + rnd() * 30), 0.8, C.gold); });
    }
    /* Akt 4: Finale. Dichte Salve, Bomben größer und höher, Goldregen-Vorhang, drei Salut-Blitze. */
    for (i = 0; i < 26; i++) {
      t = 54000 + i * 300;
      x = 1345 + (i * 61) % 190;
      sh(t, { type: ["peony", "chrys", "crossette", "peony", "strobe"][i % 5], size: 0.8 + i * 0.03, top: T(130 - i * 1.2), x: X(x), pal: i % 7 === 6 ? C.violet : pick(warm) });
      if (i % 4 === 3) { cue(t, function (now) { mine(now, X(1370 + rnd() * 150), 1, C.orange); }); }
    }
    for (i = 0; i < 5; i++) { sh(60200 + i * 260, { type: "willow", size: 1.1, top: T(118 + (i % 2) * 8), x: X(1350 + i * 45), pal: C.gold }); }   /* Goldregen-Vorhang */
    sh(62400, { type: "salute", size: 1.0, top: T(112), x: X(1400) });
    sh(62900, { type: "salute", size: 1.1, top: T(106), x: X(1490) });
    sh(63500, { type: "salute", size: 1.4, top: T(98),  x: X(1445) });
    cue(63500, function (now) { mine(now, X(1380), 1.2, C.silver); mine(now, X(1445), 1.2, C.silver); mine(now, X(1510), 1.2, C.silver); });
    /* Akt 5: Ausklang. Eine letzte, langsame Weide, dann nichts mehr. */
    sh(66500, { type: "willow", size: 0.8, top: T(150), x: X(1440), pal: C.gold });
    cues.sort(function (a, b) { return a.t - b.t; });
    return cues;
  }
  var cues = compose(), cueIx = 0, showStart = performance.now() + 1500;

  /* ---------- Render ---------- */
  var last = 0, prev = 0;
  (function tick(now) {
    if (stopped) return;
    requestAnimationFrame(tick);
    if (document.hidden || !cv.width) { prev = now; showStart += now - (last || now); last = now; return; }   /* Tab im Hintergrund: Show anhalten */
    if (now - last < 33) return;
    var dt = Math.min(50, now - prev) / 1000; prev = now; last = now;

    /* Choreografie abspielen, nach der Pause von vorn */
    var st = now - showStart;
    if (st > SHOW_LEN + PAUSE) { showStart = now; cueIx = 0; cues = compose(); st = 0; }
    while (cueIx < cues.length && cues[cueIx].t <= st) { cues[cueIx].fn(now); cueIx++; }

    ctx.globalCompositeOperation = "source-over"; ctx.globalAlpha = 1;
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, cv.width, cv.height);
    ctx.setTransform(view.scale, 0, 0, view.scale, view.x, view.y);   /* Bildkoordinaten, wie object-fit: cover */
    ctx.globalCompositeOperation = "lighter"; ctx.lineCap = "round";
    var i, s, p, e, t, alpha, rad, g, col;

    /* Bomben im Aufstieg: heller Kopf, Schweif; Kometen mit Funkenspur */
    for (i = shells.length - 1; i >= 0; i--) {
      s = shells[i]; p = (now - s.t0) / s.dur;
      if (p >= 1) { s.y = s.top; open(s, now); shells.splice(i, 1); continue; }
      e = 1 - Math.pow(1 - p, 2.2);
      s.x = s.x0 + s.drift * e; s.y = GROUND - (GROUND - s.top) * e;
      ctx.globalAlpha = 0.5 * (1 - p * 0.6); ctx.strokeStyle = "#ffd9a0"; ctx.lineWidth = (s.comet ? 2.2 : 1.3) * k;
      ctx.beginPath(); ctx.moveTo(s.x * k, s.y * k); ctx.lineTo((s.x - s.drift * 0.08) * k, (s.y + (s.comet ? 18 : 9) + 6 * (1 - p)) * k); ctx.stroke();
      ctx.globalAlpha = 0.9; ctx.fillStyle = "#fff4dc"; ctx.beginPath(); ctx.arc(s.x * k, s.y * k, (s.comet ? 2.2 : 1.6) * k, 0, TAU); ctx.fill();
      if (s.comet && rnd() < 0.5) { spark(s.x, s.y, (rnd() - 0.5) * 6, 8 + rnd() * 6, { now: now, pal: C.gold, life: 500 + rnd() * 300, r: 0.9, trail: 1.5, g: 30 }); }
    }

    /* Funken */
    for (i = sparks.length - 1; i >= 0; i--) {
      p = sparks[i]; t = (now - p.t0) / p.life;
      if (t >= 1) {
        if (p.split) {   /* Crossette: teilt sich in vier Sterne */
          var j; for (j = 0; j < 4; j++) { var a = j * Math.PI / 2 + Math.PI / 4, v = 22;
            spark(p.x, p.y, p.vx * 0.3 + Math.cos(a) * v, p.vy * 0.3 + Math.sin(a) * v, { now: now, pal: p.pal, life: 900 + rnd() * 400, r: 1.3, trail: 2.5 }); }
          spark(p.x, p.y, 0, 0, { now: now, pal: p.pal, life: 160, flash: true, r: 9 });
        }
        sparks.splice(i, 1); continue;
      }
      if (p.flash) {
        rad = p.r * (0.6 + 0.4 * t) * k;
        g = ctx.createRadialGradient(p.x * k, p.y * k, 0, p.x * k, p.y * k, rad);
        g.addColorStop(0, "rgba(255,248,230," + (0.42 * (1 - t)) + ")"); g.addColorStop(0.3, "rgba(255,225,170," + (0.16 * (1 - t)) + ")"); g.addColorStop(1, "rgba(255,200,120,0)");
        ctx.globalAlpha = 1; ctx.fillStyle = g; ctx.beginPath(); ctx.arc(p.x * k, p.y * k, rad, 0, TAU); ctx.fill();
        continue;
      }
      p.vy += p.g * dt; p.vx *= p.drag; p.vy *= p.drag;
      p.px = p.x; p.py = p.y; p.x += p.vx * dt; p.y += p.vy * dt;
      alpha = Math.pow(1 - t, p.fade);
      if (p.glitter && Math.sin(now / 40 + p.x * 3) < 0.1) alpha *= 0.2;
      col = t < 0.35 ? p.pal[0] : p.pal[1];
      ctx.strokeStyle = col; ctx.globalAlpha = Math.min(1, alpha * 0.95); ctx.lineWidth = p.r * (1 - t * 0.5) * 2 * k;
      ctx.beginPath(); ctx.moveTo((p.x - (p.x - p.px) * p.trail) * k, (p.y - (p.y - p.py) * p.trail) * k); ctx.lineTo(p.x * k, p.y * k); ctx.stroke();
      ctx.globalAlpha = Math.min(1, alpha * 0.12); ctx.fillStyle = p.pal[1];
      ctx.beginPath(); ctx.arc(p.x * k, p.y * k, p.r * 3 * k, 0, TAU); ctx.fill();
    }
    ctx.globalAlpha = 1;
  })(performance.now());

  return function stop() {
    stopped = true;
    if (ro) { ro.disconnect(); } else { window.removeEventListener("resize", fit); }
  };
}
